define(['rest/utils', 'http', 'security', './request/requestParamsFactory',
    'lodash/core', './request/contentTypeConfigurer'],
function(utils, http, security, createRequestParams, _, contentTypeConfigurer) {

    return function(fields, endpoint) {
        return function(options, callback) {
            var requestParams = createRequestParams(fields, contentTypeConfigurer.setValue(options)),
                pathParams = requestParams.pathParams,
                queryParams = requestParams.queryParams,
                httpOptions,
                bodyParams;

            queryParams.key = utils.or(options.key, security.getKey('services/routing'));
            queryParams.key = utils.required(queryParams.key);

            httpOptions = {
                url: '{protocol}://' + endpoint,
                pathParameters: pathParams,
                queryParameters: queryParams,
                callbackParam: 'callback',
                callback: callback,
                fail: options.fail
            };

            bodyParams = requestParams.postParams;

            if (_.isEmpty(bodyParams)) {
                http.get(httpOptions);
            } else {
                httpOptions.bodyParameters = bodyParams;
                http.post(httpOptions);
            }
        };
    };
});



// WEBPACK FOOTER //
// ./rest/routing/singleRequestServiceFactory.js